module.exports = __webpack_public_path__ + "img/6549cccbecbaa765312971fa156ca248.d7425b88.webp";